import { VBottomNavigation } from 'vuetify/lib/components/VBottomNavigation';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"city-header"}},[_c(VRow,[_c(VCol,[_c('h2',[_vm._v(_vm._s(_vm.city))])])],1),_c(VRow,[_c(VCol,[_c(VBottomNavigation,{attrs:{"value":_vm.activeBtn,"color":"primary"}},[_c(VDivider,{attrs:{"vertical":""}}),_c(VBtn,{attrs:{"to":'/cidade/' + _vm.cityId}},[_c('span',[_vm._v("Geral")])]),(
            _vm.isFullAdmin ||
              ((_vm.isIndicadores || !_vm.isIndicadores) &&
                _vm.config.acompanhamentos &&
                _vm.groupsConfig.acompanhamentos)
          )?_c(VDivider,{attrs:{"vertical":""}}):_vm._e(),(
            _vm.isFullAdmin ||
              ((_vm.isIndicadores || !_vm.isIndicadores) &&
                _vm.config.acompanhamentos &&
                _vm.groupsConfig.acompanhamentos)
          )?_c(VBtn,{attrs:{"to":'/cidade/' + _vm.cityId + '/acompanhamento'}},[_c('span',[_vm._v("Acompanhamentos")])]):_vm._e(),(
            _vm.isFullAdmin ||
              ((!_vm.isNA || (_vm.config.relatorios && _vm.groupsConfig.relatorios)) &&
                !_vm.isIndicadores &&
                !_vm.isSala)
          )?_c(VDivider,{attrs:{"vertical":""}}):_vm._e(),(
            _vm.isFullAdmin ||
              ((!_vm.isNA || (_vm.config.relatorios && _vm.groupsConfig.relatorios)) &&
                !_vm.isIndicadores &&
                !_vm.isSala)
          )?_c(VBtn,{attrs:{"to":'/cidade/' + _vm.cityId + '/relatorio'}},[_c('span',[_vm._v("Relatórios")])]):_vm._e(),(
            _vm.isFullAdmin ||
              ((!_vm.isNA || (_vm.config.calendario && _vm.groupsConfig.calendario)) &&
                !_vm.isIndicadores &&
                !_vm.isSala)
          )?_c(VDivider,{attrs:{"vertical":""}}):_vm._e(),(
            _vm.isFullAdmin ||
              ((!_vm.isNA || (_vm.config.calendario && _vm.groupsConfig.calendario)) &&
                !_vm.isIndicadores &&
                !_vm.isSala)
          )?_c(VBtn,{attrs:{"to":'/cidade/' + _vm.cityId + '/evento'}},[_c('span',[_vm._v("Calendário")])]):_vm._e(),(_vm.isFullAdmin || (_vm.groupsConfig.evidencias && _vm.config.evidencias))?_c(VDivider,{attrs:{"vertical":""}}):_vm._e(),(_vm.isFullAdmin || (_vm.groupsConfig.evidencias && _vm.config.evidencias))?_c(VBtn,{attrs:{"to":'/cidade/' + _vm.cityId + '/evidencia/respondida'}},[_c('span',[_vm._v("Evidências")])]):_vm._e(),(
            _vm.isFullAdmin ||
              ((!_vm.isNA || (_vm.config.grupos && _vm.groupsConfig.grupos)) &&
                !_vm.isIndicadores &&
                !_vm.isSala)
          )?_c(VDivider,{attrs:{"vertical":""}}):_vm._e(),(
            _vm.isFullAdmin ||
              ((!_vm.isNA || (_vm.config.grupos && _vm.groupsConfig.grupos)) &&
                !_vm.isIndicadores &&
                !_vm.isSala)
          )?_c(VBtn,{attrs:{"to":'/cidade/' + _vm.cityId + '/grupo'}},[_c('span',[_vm._v(_vm._s(_vm.$store.state.uf === "AL" ? 'Grupos/Temas': 'Grupos'))])]):_vm._e(),(
            _vm.isFullAdmin ||
              ((!_vm.isNA || (_vm.config.andamento && _vm.groupsConfig.andamento)) &&
                !_vm.isIndicadores &&
                !_vm.isSala)
          )?_c(VDivider,{attrs:{"vertical":""}}):_vm._e(),(
            _vm.isFullAdmin ||
              ((!_vm.isNA || (_vm.config.andamento && _vm.groupsConfig.andamento)) &&
                !_vm.isIndicadores &&
                !_vm.isSala)
          )?_c(VBtn,{attrs:{"to":'/cidade/' + _vm.cityId + '/andamento'}},[_c('span',[_vm._v("Andamento")])]):_vm._e(),(
            _vm.isFullAdmin ||
              ((!_vm.isNA ||
                (_vm.config.termoReferencia && _vm.groupsConfig.termoReferencia)) &&
                !_vm.isIndicadores &&
                !_vm.isSala)
          )?_c(VDivider,{attrs:{"vertical":""}}):_vm._e(),(
            _vm.isFullAdmin ||
              ((!_vm.isNA ||
                (_vm.config.termoReferencia && _vm.groupsConfig.termoReferencia)) &&
                !_vm.isIndicadores &&
                !_vm.isSala)
          )?_c(VBtn,{attrs:{"to":'/cidade/' + _vm.cityId + '/termo-referencia'}},[_c('span',[_vm._v("Termos de Referência")])]):_vm._e(),(
            _vm.estado === 'SC1' && (_vm.isAdmin || _vm.isConsultorEspecialistaMunicipio)
          )?_c(VDivider,{attrs:{"vertical":""}}):_vm._e(),(
            _vm.estado === 'SC1' && (_vm.isAdmin || _vm.isConsultorEspecialistaMunicipio)
          )?_c(VBtn,{attrs:{"to":'/cidade/' + _vm.cityId + '/evento-em-lote'}},[_c('span',[_vm._v("Calendário em Lote")])]):_vm._e(),(
            _vm.isFullAdmin ||
              (_vm.config.relatorioAdministrativo &&
                _vm.groupsConfig.relatorioAdministrativo)
          )?_c(VDivider,{attrs:{"vertical":""}}):_vm._e(),(
            _vm.isFullAdmin ||
              (_vm.config.relatorioAdministrativo &&
                _vm.groupsConfig.relatorioAdministrativo)
          )?_c(VBtn,{attrs:{"to":'/cidade/' + _vm.cityId + '/relatorio-administrativo'}},[_c('span',[_vm._v("Relatório Administrativo")])]):_vm._e(),(_vm.isFullAdmin || (_vm.config.sala && _vm.groupsConfig.sala))?_c(VDivider,{attrs:{"vertical":""}}):_vm._e(),(_vm.isFullAdmin || (_vm.config.sala && _vm.groupsConfig.sala))?_c(VBtn,{attrs:{"to":'/sala-municipio-principal'}},[_c('span',[_vm._v("Sala")])]):_vm._e(),_c(VDivider,{attrs:{"vertical":""}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }